var $ = jQuery.noConflict();

$(document).ready(function(){
  
  $(".newsletter-form__button").on('click',function() {
    $('html, body').animate({
        'scrollTop' : $("#shopify-section-footer").position().top 
    });
  });
  setTimeout(function(){
      hide_thumb_arrows();
    },500);
  $(document).on('click', '.variant_label', function(e) {
    setTimeout(function(){
      hide_thumb_arrows();
    },500);
    setTimeout(function(){
      const variant_count = $('#variant-count').val();
        var select_html = '';
        if ( variant_count == 0 ){
          select_html = '<option value="1">1</option>';
        }
        for(var i = 1; i <= variant_count; i++){
          if(i == 11){
            break;
          }
          select_html += '<option value="'+ i +'">'+ i +'</option>'
        }
      $('.custom-quantity-dropdown select').html(select_html);
    },1500);
    
    var product_text = $(this).text();
    $(this).closest('.product-form__input').find('.value_variant').text(product_text);
    
  });
  
  $('.left_thumbnail_block .thumbnail-list__item.slider__slide .thumbnail').first().attr("aria-current","true");
  
    $(document).on('click', '.custom-arrows .next, .left_thumbnail_block .slider-button.slider-button--next', function () {
    $('.left_thumbnail_block .thumbnail-list__item.slider__slide .thumbnail[aria-current]').closest('li').next().find('button').trigger('click');
  });

  $(document).on('click', '.custom-arrows .prev, .left_thumbnail_block .slider-button.slider-button--prev', function () {
    $('.left_thumbnail_block .thumbnail-list__item.slider__slide .thumbnail[aria-current]').closest('li').prev().find('button').trigger('click');
  });
  
 
    $('.mobile-facets__summary .mobile-facets__sort .select__select').on('change', function(){
        setTimeout(function(){
            $('.mobile-facets__close').trigger('click');
        },200);
    });
  
   $("#review-tab").trigger("click");
   $(document).on('click', '.title-tabs', function(e) {
      $(event.target).next(".products-tabs-content").siblings(".products-tabs-content").slideUp("300");
      $(event.target).next(".products-tabs-content").slideToggle("300");
      $(this).toggleClass("active").siblings().removeClass('active');
      $(this).closest(".product_right").find(".easyspecs-subchart .easyspecs-title-row").removeClass('active');
      $(this).closest(".product_right").find(".easyspecs-subchart .easyspecs-subchart-content").slideUp("300");
  });

  $(document).on('click', '.react-side-draw .cart-all-btn', function(e) {
    var page_url = window.location.origin;
    setTimeout(function(){
      window.location.replace(page_url + '/cart');
    },2000);
  });
  
  $('.read-more-block > a').click(function(e){
    e.preventDefault();
    $(this).closest('.read-more-block').toggleClass('show');
  });
  
  $('.custom-modal').click(function(e){
  e.preventDefault();
  var data_id = $(this).attr('data-id');
  $('#' + data_id).addClass('open-popup');
  });
  $('.popup__close').click(function(e){
    e.preventDefault();
    $(this).closest('.custom-popup').removeClass('open-popup');
  });
  
  $('.search-btn').click(function(e){
    e.preventDefault();
    $(this).siblings('.search-modal__content').slideToggle();
      $( ".search-modal__content input" ).focus();  
    
  });
  
  $(".filter-row h5").click(function() {
    var is_open = $(this).siblings('.filters-tag').is(":visible");
    if (is_open) {
      $(this).siblings('.filters-tag').slideUp();
      $(this).closest('.filter-row').removeClass('open-dropdown');
    } else {
      $(this).siblings('.filters-tag').slideDown();
      $(this).closest('.filter-row').addClass('open-dropdown');
      $(this).closest('.filter-row').siblings('.filter-row').find('.filters-tag').slideUp();
      $(this).closest('.filter-row').siblings('.filter-row').removeClass('open-dropdown');
    }
  });


  $(document).mouseup(function(event) {

    var target = event.target;
    var select = $(".tag-filters");

    if (!select.is(target) && select.has(target).length === 0) {
      select.removeClass("open");
    }

  });
  service_block_slider();
  //  setTimeout(function(){
  // product_slider();
  //     },800);
  
  service_icon_slider();
  product_recommendation_fun();
  
  $('.most-popular-slider .shg-category-row').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    }
  ] 
  });
      
 $('.category-slider > .shg-box-content').slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    rows: 0,
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    }, 
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    }, 
  ] 
  });
      
  var data = $('#product_listing').html();
  $('.getdata .shg-box-content').html(data);
      
  $('.home-product-slider:not(.product-page-recommendations) .product-grid').not('.slick-initialized').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    rows: 0,
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        dots: true
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        dots: true
      }
    },
  ]
  });
  
});      

$(window).on('load', function() {

  $( ".klaviyo_form_trigger" ).trigger( "click" );
  
  if (window.location.href.indexOf("#ContactFooter") > -1) {
    setTimeout(function(){
      $('.shape_none').fadeIn();
    },800);
   
  }else{
    $('.shape_none').fadeIn();
  }

    $(document).on('click', '.product-grid .card-wrapper input[type=radio].color-swatches', function(e) {
      var variant_img = $(this).attr('data-img');
      var variant_id = $(this).attr('data-variant');
      $(this).closest('.card-wrapper').find('.add-to-whishlist .iWishAddColl').attr('data-variant', variant_id);
      $(this).closest('.card-wrapper').find('.add-to-cart input[type="hidden"]').val(variant_id);
      $(this).closest('.card-wrapper').find('.card .media > img').attr('src', variant_img);
      $(this).closest('.card-wrapper').find('.card .media > img').attr('srcset', '');
    });
  
  $(document).on('click', '.easyspecs-table .easyspecs-title-row', function(e) {
      $(this).siblings(".easyspecs-subchart-content").slideToggle("300");
      $(this).closest(".easyspecs-subchart").siblings(".easyspecs-subchart").find(".easyspecs-subchart-content").slideUp("300");
      $(this).closest(".product_right").find(".products-tabs .products-tabs-content").slideUp("300");
      $(this).closest(".product_right").find(".products-tabs .title-tabs").removeClass("active");
      $(this).toggleClass("active").closest(".easyspecs-subchart").siblings(".easyspecs-subchart").find(".easyspecs-title-row").removeClass('active');;
    });

  if($(window).innerWidth() <= 767){
      $(document).on('click', '.color_variant, .rio-options > .PwzrGrid-root > .PwzrGrid-item:first-child div[class*="PwzrButtonBase-root"]', function(e) {
      
      // setTimeout(function(){
      //     product_flag = false;
      //     product_slider();
      // },200);
        setTimeout(function(){
            $('html,body').animate({
                scrollTop: 0
            },800);
          },1000);
      }); 
  }

});

$( window ).on( 'resize',function() {
  service_block_slider();
    // product_slider();
    service_icon_slider();
    product_recommendation_fun();
});

var service_icon = false;
function service_icon_slider() {
  if($(".service-icon-section .service-steps-container .shg-row").length) {
  if ($(window).width() < 992) {
    if (!service_icon) {
      $(".service-icon-section .service-steps-container .shg-row").not('.slick-initialized').slick({
        dots: true,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 1200,
        infinite: false,
        rows: 0,
        responsive: [
          {
                  breakpoint: 2500,
            settings: 'unslick',
          },
                {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            }
          },
                    {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
            }
          },
        ]
      });
      service_icon = true;
    }
  } else {
      if (service_icon) {
        service_icon = false;
        $('.service-icon-section .service-steps-container .shg-row').slick('unslick');
      }
    }
  }
}

var product_recommendation = false;
function product_recommendation_fun() {
  if($(".home-product-slider.product-page-recommendations .product-grid").length) {
  if ($(window).width() < 992) {
    if (!product_recommendation) {
      $(".home-product-slider.product-page-recommendations .product-grid").not('.slick-initialized').slick({
        dots: true,
        arrows: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: false,
        infinite: false,
        rows: 0,
        responsive: [
          {
                        breakpoint: 2500,
            settings: 'unslick',
          },
                    {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            }
          },
                    {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
                            slidesToScroll: 1,
            }
          }
        ]
      });
      product_recommendation = true;
    }
  } else {
    if (product_recommendation) {
      product_recommendation = false;
            $('.home-product-slider.product-page-recommendations .product-grid').slick('unslick');
    }
  }
  }
}

var flag = false;
function service_block_slider() {
  if($(".service_offers_block").length) {
  if ($(window).width() < 992) {
    if (!flag) {
      $(".service_offers_block").not('.slick-initialized').slick({
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
                autoplaySpeed: 2000,
        speed: 1200,
        infinite: true,
        rows: 0,
        responsive: [
          {
                        breakpoint: 2500,
            settings: 'unslick',
          },
                    {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          }
        ]
      });
      flag = true;
    }
  } else {
    if (flag) {
      flag = false;
            $('.service_offers_block').slick('unslick');
    }
  }
  }
}

var product_flag = false;
function product_slider() {
  if($(".main_gallery .right_gallery_block .product__media-list ").length) {
  if ($(window).width() < 1200) {
    if (!product_flag) {
          $(".main_gallery .right_gallery_block .product__media-list ").each(function () {
      $(this).not('.slick-initialized').slick({
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
                autoplaySpeed: 3000,
        speed: 1200,
                fade:true,
        infinite: true,
        rows: 0,
        responsive: [
          {
                        breakpoint: 2500,
            settings: 'unslick',
          },
                    {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
            },
          }
        ]
      });
            });
      product_flag = true;
    }
  } else {
    if (product_flag) {
      product_flag = false;
            $('.main_gallery .right_gallery_block .product__media-list').slick('unslick');
    }
  }
  }
}

// hide thumb arrows
function hide_thumb_arrows() {
  if($('.main_gallery .left_thumbnail_block .starapps .slider.thumbnail-list .thumbnail-list__item').length < 4) {
    $('.product--thumbnail_slider .left_thumbnail_block .slider-mobile-gutter .slider-button').hide();
  }
  else {
    $('.product--thumbnail_slider .left_thumbnail_block .slider-mobile-gutter .slider-button').show();
  }
}